import { FunctionComponent, useContext, useState } from "react";
import FilterTitle from "./FilterTitle";
import styles from "./FilterDropdown.module.css";
import images from "../../../../assets/images/index";
import "react-datepicker/dist/react-datepicker.css";
import { FormControlLabel, Radio, RadioGroup, Slider } from "@mui/material";
import { useLazyQuery } from "@apollo/client";
import { GET_LEAGUES_LIST } from "../../../../features/Tickets/api/TicketsQuery";
import { DateFilter, LeagueListMenu, ResetApplyButtons, convertStringToDate, extractLeagues, formatDateWithHyphen, showCustomRange } from "../../../../helper";
import { globalContext } from "../../../../Provider/AppProvider";

interface filterdropdownprops {
  activetab ?: number
  handleCloseFilterDropDown: () => void
}

const thumbStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 40,
  height: 20,
  borderRadius: "0",
  backgroundColor: "#5D75F8",
  color: "#fff",
  fontSize: "8px",
  position: "relative",
  top: "-8px",
  padding: "2px"
};

export interface LeagueObjectType{
  l_id: string,
  l_name: string,
}
interface LeaguesList{
    leagues: LeagueObjectType[]
}
const ManageTicketFilterDropdown: FunctionComponent<filterdropdownprops> = ({handleCloseFilterDropDown}) => {
  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  const [manageFilterStartDate,setManageFilterStartDate] = useState<string | null>(null);
  const [manageFilterEndDate, setManageFilterEndDate] = useState<string | null>(null);
  const [manageFilterStartDateRange,setManageFilterStartDateRange] = useState<string | null>(null);
  const [manageFilterEndDateRange, setManageFilterEndDateRange] = useState<string | null>(null);
  const [manageFilterLeagueId,setManageFilterLeagueId] = useState<string | null>(globalState.manageTicketFilter.leagueId || null);
  const { dropdownIcon } = images;
  const [value, setValue] = useState(globalState.manageTicketFilter.periodLeft || null);
  const [anchorEl, setAnchorEl] = useState<EventTarget | null>(null);
  const [league , setLeague] = useState<string>(globalState.manageTicketFilter.leagueName || "")
  const [valueradio, setValueRadio] = useState<string | null>(globalState.manageTicketFilter.validstatus ? globalState.manageTicketFilter.validstatus : null);
  const [days, setDays] = useState<string>(globalState.manageTicketFilter.selectedDateValue || "")
  const [startDate, setStartDate] = useState<any>('');
  const [endDate, setEndDate] = useState<any>('');
  const [showDatePicker, setShowDatePicker] = useState<boolean>(false);
  const [customRange, setCustomrange] = useState<boolean>(false);
  const min = 1;
  const max = 7;
const [leagueslistData,setLeaguesList] = useState<LeaguesList>();

  const [getLeaguesList] = useLazyQuery(GET_LEAGUES_LIST, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if(data){
        const extractData = data?.leagues
        ?.filter((item: LeagueObjectType) => !extractLeagues.includes(item?.l_name))
        .map((result:LeagueObjectType) => result);
             setLeaguesList(extractData);
      }
    }
   });

  const handleChange = (event: number | number[]) => {
    setValue(event);
    setStartDate('');
    setEndDate('');
    setManageFilterStartDateRange(null);
    setManageFilterEndDateRange(null);
    setManageFilterStartDate(null);
    setManageFilterEndDate(null);
    setDays('');
  };

  const handleClickOpenMenu = (e: React.MouseEvent<HTMLInputElement>) =>{
    setAnchorEl(e.currentTarget);
    getLeaguesList();
  }

  const handleCloseMenu = ()=>{
    setAnchorEl(null);
  }

  const open = Boolean(anchorEl);

  const handleSelectleague = (league: LeagueObjectType) =>{
    setLeague(league?.l_name);
    setManageFilterLeagueId(league?.l_id);
    setAnchorEl(null)
  }

  const handleCancel = () =>{
    const tempData = {...globalState};
    tempData.manageTicketFilter.leagueId = null;
    tempData.manageTicketFilter.validstatus = null;
    tempData.manageTicketFilter.startdate = null;
    tempData.manageTicketFilter.enddate = null;
    tempData.manageTicketFilter.periodLeft = null;
    tempData.manageTicketFilter.leagueName = '';
    tempData.manageTicketFilter.selectedDateValue = '';
    tempData.manageTicketFilter.isCustomRange = false;
    tempData.manageTicketFilter.startDateRange = null;
    tempData.globalSearch.searchcance = false;
    tempData.globalSearch.searchcancel = false;
    tempData.manageTicketFilter.endDateRange = null;
    tempData.manageTicketFilter.isFilter = false;
    tempData.manageTicketFilter.clicked = true;
    handleGlobalState(tempData);
    setLeague("")
    setValue(null)
    setValueRadio(null)
    setDays("")
    setStartDate("");
    setEndDate("");
    setManageFilterStartDate(null);
    setManageFilterEndDate(null);
    setManageFilterStartDateRange(null);
    setManageFilterEndDateRange(null);
    setManageFilterLeagueId(null);
    setShowDatePicker(false)
    setCustomrange(false)
  }


  const handleChangeValidate = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValueRadio(event.target.value);
  };

  const handleClickDays = (day: string) =>{
    setValue(null);
    setStartDate('');
    setEndDate('');
    setManageFilterStartDateRange(null);
    setManageFilterEndDateRange(null);
    const {startdate,enddate} = convertStringToDate(day);
    setManageFilterStartDate(startdate);
    setManageFilterEndDate(enddate);
    setDays(day)
  }

  const onChange = (dates: [start: Date,end: Date]) => {
    setValue(null);
    const [start, end] = dates; 
    setManageFilterStartDate(null);
    setManageFilterEndDate(null);
    setManageFilterStartDateRange(start  && formatDateWithHyphen(start));
    setManageFilterEndDateRange(end && formatDateWithHyphen(end));
    setStartDate(start);
    setEndDate(end);
    setDays('')
    setCustomrange(false)
  };

  const handleClickCustomRange = () =>{
    setShowDatePicker(true)
    setDays('')
    setCustomrange(false);
  }

  const handleClickOutside = () =>{
    setShowDatePicker(false)
    setCustomrange(true)
    setDays('')
    if(endDate === null){
      setManageFilterEndDateRange(startDate && formatDateWithHyphen(startDate));
      setEndDate(startDate)
    }
  }

const showDayTick = () => {
  if(value){
    return '';
  }else{
    if(manageFilterStartDateRange && manageFilterEndDateRange){
      return '';
    }else {
      if(days === '' && globalState.manageTicketFilter.selectedDateValue === ''){
        return '';
      }else if(days){
        return days;
      }else if(globalState.manageTicketFilter.selectedDateValue){
        return globalState.manageTicketFilter.selectedDateValue;
      }
    }
  }
}

const showCustomRangeValues = () => {
  if(value){
    return '';
  }else {
    if(manageFilterStartDate){
      return '';
    }else {
      if(customRange === false && globalState.manageTicketFilter.isCustomRange === false){
        return;
       }else if(customRange){
         return (<span className={styles.dateformat}>{showCustomRange(startDate,endDate,"manage",globalState)}</span>);
       }else if(globalState.manageTicketFilter.isCustomRange){
         return (<span className={styles.dateformat}>{showCustomRange(startDate,endDate,"manage",globalState)}</span>);
       }
    }
  }
}
const handleSubmitManageFilter = () => {
  const tempData = {...globalState};
  if(manageFilterLeagueId || valueradio || manageFilterStartDate || manageFilterStartDateRange || value){
    tempData.manageTicketFilter.isFilter = true;
    tempData.manageTicketFilter.clicked = true;
  } 
  if(value){
    tempData.manageTicketFilter.periodLeft = value;
    tempData.manageTicketFilter.startdate = null;
    tempData.manageTicketFilter.enddate = null;
    tempData.manageTicketFilter.startDateRange = null;
    tempData.manageTicketFilter.endDateRange = null;
  }else {
    tempData.manageTicketFilter.periodLeft = value;
    if(manageFilterStartDateRange && manageFilterEndDateRange){
      tempData.manageTicketFilter.startdate = null;
      tempData.manageTicketFilter.enddate = null;
      tempData.manageTicketFilter.startDateRange = manageFilterStartDateRange ? manageFilterStartDateRange : globalState.manageTicketFilter.startDateRange;
      tempData.manageTicketFilter.endDateRange = manageFilterEndDateRange ? manageFilterEndDateRange : globalState.manageTicketFilter.endDateRange ;
    }else {
      if(manageFilterStartDate && manageFilterEndDate){
        tempData.manageTicketFilter.startdate = manageFilterStartDate;
        tempData.manageTicketFilter.enddate = manageFilterEndDate;
        tempData.manageTicketFilter.startDateRange = null;
        tempData.manageTicketFilter.endDateRange = null;
      }else if(manageFilterStartDate){
        tempData.manageTicketFilter.startdate = manageFilterStartDate;
        tempData.manageTicketFilter.enddate = null;
        tempData.manageTicketFilter.startDateRange = null;
        tempData.manageTicketFilter.endDateRange = null;
      }
    }
  }
  tempData.manageTicketFilter.leagueId = manageFilterLeagueId;
  tempData.manageTicketFilter.validstatus = valueradio ? valueradio : null;
  tempData.manageTicketFilter.leagueName = league;
  tempData.manageTicketFilter.selectedDateValue = days;
  if(manageFilterStartDateRange && manageFilterEndDateRange){
  tempData.manageTicketFilter.isCustomRange = true;
  }
  handleGlobalState(tempData);
  handleCloseFilterDropDown();
}
  return (
    <div className={styles.filterDropdown} >
      <div className={styles.top}>
        <FilterTitle handleCloseFilterDropDown={handleCloseFilterDropDown}/>
        <div className={styles.filterContainer}>
          <div className={styles.container}>
            <div className={styles.filterDetails}>
              <div className={styles.textFieldFullMain}>
                <div className={styles.titlePlaceholder}>
                  <b className={styles.event}>Event</b>
                </div>
                <div className={styles.textField} onClick={handleClickOpenMenu}>
                  <div className={styles.container1}>
                    <div
                      className={
                        league === "" ? styles.select : styles.leagueSelect
                      }
                    >
                      {league ? league : '--Select--'}
                    </div>
                    <img
                      className={styles.sharpOutlineDropdown}
                      alt="dropdownIcon"
                      src={dropdownIcon}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.validate}>
                <div>
                  <b className={styles.validate1}>Validate</b>
                </div>
                <div
                  className={styles.radiogroup}
                >
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={valueradio}
                    onChange={handleChangeValidate}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div>
                      <FormControlLabel
                        value = 'Verified'
                        control={
                          <Radio
                            sx={{
                              color: "#B9BDC6",
                              "&.Mui-checked": {
                                color: "#5D75F8",
                              },
                                                    
                            }}
                          />
                        }
                        label=""
                      />
                      <span className={styles.radiovalid}>Valid</span>
                    </div>
                    <div>
                      <FormControlLabel
                        value = 'Delist'
                        control={
                          <Radio
                            sx={{
                              color: "#B9BDC6",
                              "&.Mui-checked": {
                                color: "#5D75F8",
                              },
                             
                            }}
                          />
                        }
                        label=""
                      />
                      <span className={styles.radiovalid}>Invalid</span>
                    </div>
                    <div>
                      <FormControlLabel
                        value="DelistInProgress"
                        control={
                          <Radio
                            sx={{
                              color: "#B9BDC6",
                              "&.Mui-checked": {
                                color: "#5D75F8",
                              }
                            }}
                          />
                        }
                        classes={{
                          root: styles.delistFormLabelStyle
                        }}
                        label=""
                      />
                      <span className={styles.radioDelistRequested}>Delist Requested</span>
                    </div>
                  </RadioGroup>
                </div>
              </div>
              <DateFilter 
                handleClickDays={handleClickDays}
                showDayTick={showDayTick} 
                handleClickCustomRange={handleClickCustomRange}
                showCustomRangeValues={showCustomRangeValues} 
                showDatePicker={showDatePicker} 
                startDate={startDate}
                endDate={endDate}
                handleClickOutside={handleClickOutside} 
                onChange={onChange}
              />
              <div className={styles.validate}>
                <div>
                  <b className={styles.validate1}>Period Left</b>
                </div>
                <div
                 className={styles.periodleft}
                >
                  <span className={styles.sliderbarrangeMinmax}>
                    {min} day
                  </span>
                  <span className={styles.sliderbarrangeMinmax}>
                    {max} days
                  </span>
                </div>
                <div className={styles.sliderdiv}>
                  <Slider
                    value={value}
                    onChange={(e, newValue) => {
                      handleChange(newValue);
                    }}
                    step={1}
                    marks={false}
                    min={min}
                    max={max}
                    classes={{
                      root : styles.sliderstyle
                    }}
                    sx={{
                      "& .MuiSlider-thumb": {
                        ...thumbStyle,
                        zIndex: 1, 
                        "&:hover": {
                          boxShadow: "none", 
                        },
                      },
                      "& .MuiSlider-track": {
                        backgroundColor: "#5D75F8",
                        borderRadius: "0px",
                      },
                      "& .MuiSlider-rail": {
                        backgroundColor: "#E3E5E8",
                        borderRadius: "0px",
                        width : "326px !important"
                      },
                     
                    }}
                    components={{
                      Thumb: ({ children, ...other }) => (
                        <div style={thumbStyle} {...other}>
                          <span>{value === 1 ? `${value} DAY` : (value === null) ? `DAY` :`${value} DAYS`}</span>
                          {children}
                        </div>
                      ),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <ResetApplyButtons handleCancel={handleCancel} handleSubmit= {handleSubmitManageFilter}/>
        </div>
      </div>
      <LeagueListMenu
        anchorEl ={anchorEl}
        open= {open}
        selectedLeague = {league}
        handleCloseMenu ={handleCloseMenu}
        handleSelectleague={handleSelectleague}
        leagueslistData = {leagueslistData}
      />
    </div>
  );
};

export default ManageTicketFilterDropdown;
